import { styled, TableRow, Stack } from '@mui/material';

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even) td': {
    backgroundColor: theme.palette.blue100.main,
  },
  '&:hover td': {
    backgroundColor: theme.palette.blue100.main,
  },
}));

export const CreditScore = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: 8,
  color: theme.palette.orange.main,
}));
